'use strict';

angular.module('imagetrend.components')
    .directive('hlpRadios', ['$injector', 'Format', '$timeout', function ($injector, Format, $timeout) {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=',
                question: '=?',
                name: '@?',
                id: '@?',
                showLabel: '@?',
                updateService: '@?',
                isRequired: '=?',
                showRequired: '=?',
                options: '=?',
                label: '@?',
                title: '@?',
                requiredText: '@?',
                instructions: '@?',
                classes: '@?',
                selectShow: '@?',
                selectValue: '@?',
                service: '@?',
                method: '@?',
                isDisabled: '=?',
                topLabel: '=?',
                modal: '@?',
                showColon: '=?',
                vertical: '=?',
                parameters: '=?',
                pdf: '=?',
                showValue: '=?',
                groups: '=?' // for service user affiliations (positions) / service vehicles
            },
            require: 'ngModel',
            transclude: true,
            replace: true,
            templateUrl: 'templates/radios/radios.html',
            controller: ['$scope', '$timeout', function ($scope, $timeout) {
                $scope.validate = function () {
                    if ($scope.innerForm !== undefined) {
                        if ($scope.isRequired) {
                            if ($scope.ngModel == null || $scope.ngModel.length == 0) {
                                $scope.innerForm[$scope.name].$setValidity("required", false);
                            }
                            else {
                                $scope.innerForm[$scope.name].$setValidity("required", true);
                            }
                        }
                        if ($scope.question !== undefined && $scope.question.answer !== undefined && $scope.innerForm != null && $scope.innerForm[$scope.name] != null) {
                            $scope.question.answer.invalid = !isEmpty($scope.innerForm[$scope.name].$error);
                        }
                    }
                }
                var validationTimeout = $timeout(function() {
                    if (!$scope.requiredText) { $scope.requiredText = 'Please enter a ' + Format.label(($scope.label || 'value')) }
                    $scope.validate();
                }, 0);

                $scope.$on('$destroy', function () {
                    $timeout.cancel(validationTimeout);
                });
            }],
            compile: function (elem, attrs) {
                return {
                    pre: function (scope, elem, attrs, ngModel) {

                        if (!attrs.name) { attrs.name = 'radios'; }
                        if (!attrs.id) { attrs.id = attrs.name; }
                        if (!attrs.label) { attrs.label = Format.label(attrs.name); } 
                        if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                        if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                        if (!attrs.updateService) { attrs.updateService = true; } else { if (attrs.updateService == true || attrs.updateService == 'true') { attrs.updateService = true; } else { attrs.updateService = false; } }
                        if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }
                        //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                        if (!attrs.title) { attrs.title = Format.label(attrs.name); }

                        if (!attrs.selectShow) { attrs.selectShow = 'name'; }
                        if (!attrs.selectValue) { attrs.selectValue = 'id'; }
                        if (!attrs.method) { attrs.method = 'get'; }
                        if (!attrs.modal) { attrs.modal = false; } else { if (attrs.modal == 'true') { attrs.modal = true; } else { attrs.modal = false; } }
                        if (!attrs.forceString) { attrs.forceString = false; } else { if (attrs.forceString == 'true') { attrs.forceString = true; } else { attrs.forceString = false; } }
                        if (!attrs.vertical) { attrs.vertical = false; } else { if (attrs.vertical == 'true') { attrs.vertical = true; } else { attrs.vertical = false; } }

                        scope.optionsLoaded = false;
                        scope.dirOptions = [];
                        var optionsRequestId = 0;
                        scope.getOptions = function () {
                            if (scope.options != null && !(scope.service != null && scope.service != '' && scope.serviceOverride)) {
                                if (Object.prototype.toString.call(scope.options) !== '[object Array]') {
                                    scope.options.split(',').forEach(function (option) {
                                        scope.dirOptions.push({ id: option.trim(), name: option.trim() });
                                    });
                                    scope.optionsLoaded = true;
                                }
                                else {
                                    scope.$evalAsync(function () {
                                        scope.dirOptions = scope.options;
                                        scope.optionsLoaded = true;
                                    });
                                }
                            }
                            else if (scope.service != null && scope.service != '') {
                                var service = $injector.get(scope.service);
                                var requestId = ++optionsRequestId;

                                service[scope.method](scope.parameters).then(function (data) {
                                    if (requestId !== optionsRequestId) { return; }
                                    scope.dirOptions = data;
                                    if (attrs.updateService) {
                                        scope.options = data;
                                    }
                                    scope.optionsLoaded = true;
                                });
                                scope.$on('$destroy', function () {
                                    service = null;
                                });
                            }
                            else {
                                scope.optionsLoaded = true;
                            }
                        };
                        scope.getOptions();

                        // Reload options whenever vehicle_id is updated as a Service Vehicle, since we pull
                        // Primary Cert Category Data, which can differ (mirrors hlp-checkboxes behavior)
                        if (scope.parameters && scope.parameters.service_id != null && scope.parameters.vehicle_id != null && scope.service != null && scope.service != "") {
                            var vehicleGroupIdx = -1;
                            if (scope.groups && scope.question) {
                                for (var vgi = 0; vgi < scope.groups.length; vgi++) {
                                    if (scope.groups[vgi].id === scope.question.group_id) {
                                        vehicleGroupIdx = vgi;
                                        break;
                                    }
                                }
                            }
                            if (vehicleGroupIdx > -1) {
                                scope.$watch("groups[" + vehicleGroupIdx + "].parameters.vehicle_id", function (newVal) {
                                    if (newVal != null) {
                                        scope.options = null;
                                        scope.optionsLoaded = false;
                                        scope.dirOptions = [];
                                        scope.getOptions();
                                    }
                                });
                            }
                        }

                        // watch if options is coming from an array that hasn't been set yet
                        scope.$watch('options', function (options) {
                            if (options != null && scope.optionsLoaded && scope.service == null) {
                                scope.optionsLoaded = false;
                                scope.dirOptions = [];

                                if (Object.prototype.toString.call(scope.options) !== '[object Array]') {
                                    scope.options.split(',').forEach(function (option) {
                                        scope.dirOptions.push({ id: option.trim(), name: option.trim() });
                                    });
                                }
                                else {
                                    scope.dirOptions = scope.options;
                                }
                                scope.optionsLoaded = true;
                            }
                        });

                        scope.$watch('optionsLoaded', function (optionsLoaded) {
                            if (optionsLoaded && scope.showValue == null) {
                                scope.setShowValue();
                            }
                            var timer = $timeout(function () {
                                if (scope.isRequired && (scope.innerForm !== undefined)) {
                                    if (ngModel.$modelValue == null || ngModel.$modelValue.length == 0) {
                                        scope.innerForm[scope.name].$setValidity("required", false);
                                    }
                                    else {
                                        scope.innerForm[scope.name].$setValidity("required", true);
                                    }
                                }
                            }, 0);
                            scope.$on('$destroy', function () {
                                $timeout.cancel(timer);
                            });
                        })

                        scope.setShowValue = function () {
                            if (ngModel.$modelValue != null && scope.dirOptions != null) {
                                scope.showValue = null;
                                scope.dirOptions.forEach(function (opt) {
                                    if (opt.id == ngModel.$modelValue) {
                                        scope.showValue = opt.name;
                                    }
                                })
                            }
                        }

                        ngModel.$render = function () {
                            if (ngModel.$modelValue != null) {
                                if (scope.showValue == null && scope.optionsLoaded) {
                                    scope.setShowValue();
                                }
                            }
                        }

                        scope.onChange = function (item) {
                            scope.submitted = false;
                            scope.processingChange = true;
                            ngModel.$setViewValue(item);
                            scope.$evalAsync(function () {
                                scope.setShowValue();
                                if (scope.isRequired) {
                                    if (ngModel.$modelValue == null || ngModel.$modelValue.length == 0) {
                                        scope.innerForm[scope.name].$setValidity("required", false);
                                    }
                                    else {
                                        scope.innerForm[scope.name].$setValidity("required", true);
                                    }
                                }
                                if (scope.question !== undefined && scope.question.answer !== undefined && scope.innerForm != null && scope.innerForm[scope.name] != null) {
                                    scope.question.answer.invalid = !isEmpty(scope.innerForm[scope.name].$error);
                                }
                                scope.processingChange = false;
                            });
                        }

                        scope.submitted = false;
                        scope.$on('form:submit', function () {
                            scope.validate();
                            scope.submitted = true;
                        });

                        scope.$on('$destroy', function () {
                        });
                    }
                }
            }
        };
    }])

;